import { render } from "./estadisticas.vue?vue&type=template&id=c36c6dec&scoped=true"
import script from "./estadisticas.vue?vue&type=script&lang=js"
export * from "./estadisticas.vue?vue&type=script&lang=js"

import "./estadisticas.vue?vue&type=style&index=0&id=c36c6dec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36c6dec"]])

export default __exports__